import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onboardingAPI } from '../../services/api';
import { parseApiError } from '../../utils/errors';
import { copyText } from '../../utils/clipboard';

export default function NewStudent() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    student_name: '', student_class: '', parent_number: '',
    syllabus: '', subjects_required: '', mode: 'offline', remarks: '',
    full_location: '', nearby_locations: '', landmark: '', travel_notes: '', location_link: '',
  });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [copied, setCopied] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const copyLocation = async () => {
    if (await copyText(form.location_link)) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setSaving(true);
    try {
      const payload = { ...form, syllabus: form.syllabus || null };
      const { data } = await onboardingAPI.create(payload);
      navigate(`/onboarding/${data.id}`);
    } catch (err) {
      setError(parseApiError(err, 'Failed to create'));
      setSaving(false);
    }
  };

  const isOffline = form.mode === 'offline';

  return (
    <div className="page">
      <div className="page-header">
        <h2>New Student Entry</h2>
        <button className="btn btn-ghost" onClick={() => navigate('/onboarding')}>← Back</button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={submit} className="form-card">
        <h4>Student Information</h4>
        <div className="form-row">
          <div className="form-group" style={{ flex: 2 }}>
            <label>Student Name *</label>
            <input required value={form.student_name} onChange={set('student_name')} />
          </div>
          <div className="form-group">
            <label>Class</label>
            <input value={form.student_class} onChange={set('student_class')} />
          </div>
          <div className="form-group">
            <label>Parent Number</label>
            <input value={form.parent_number} onChange={set('parent_number')} />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Syllabus</label>
            <select value={form.syllabus} onChange={set('syllabus')}>
              <option value="">Select…</option>
              <option value="cbse">CBSE</option>
              <option value="icse">ICSE</option>
              <option value="state">State</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className="form-group">
            <label>Mode</label>
            <select value={form.mode} onChange={set('mode')}>
              <option value="offline">Offline</option>
              <option value="online">Online</option>
            </select>
          </div>
          <div className="form-group" style={{ flex: 2 }}>
            <label>Subjects Required</label>
            <input value={form.subjects_required} onChange={set('subjects_required')} placeholder="e.g. Maths, Physics" />
          </div>
        </div>

        <div className="form-group">
          <label>Remarks</label>
          <textarea rows={2} value={form.remarks} onChange={set('remarks')} />
        </div>

        {isOffline && (
          <>
            <h4 className="mt-4">Location Details</h4>
            <div className="form-row">
              <div className="form-group" style={{ flex: 2 }}>
                <label>Full Location</label>
                <textarea rows={2} value={form.full_location} onChange={set('full_location')} />
              </div>
              <div className="form-group">
                <label>Landmark</label>
                <input value={form.landmark} onChange={set('landmark')} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Nearby Locations</label>
                <textarea rows={2} value={form.nearby_locations} onChange={set('nearby_locations')} />
              </div>
              <div className="form-group">
                <label>Travel Notes</label>
                <textarea rows={2} value={form.travel_notes} onChange={set('travel_notes')} />
              </div>
            </div>
            <div className="form-group">
              <label>Location Link (Google Maps or similar)</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input
                  value={form.location_link}
                  onChange={set('location_link')}
                  placeholder="https://maps.google.com/..."
                  style={{ flex: 1 }}
                />
                <button type="button" className="btn btn-ghost" onClick={copyLocation} disabled={!form.location_link}>
                  {copied ? '✓ Copied' : '📋 Copy'}
                </button>
              </div>
            </div>
          </>
        )}

        <div className="form-actions">
          <button type="button" className="btn btn-ghost" onClick={() => navigate('/onboarding')}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Create & Continue'}</button>
        </div>
      </form>
    </div>
  );
}
